import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import authService from '../services/authService';
import { getSafePostLoginRedirect } from '../lib/loginRedirect';

const CheckLogin = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = authService.isLoggedIn();

  useEffect(() => {
    if (!isLoggedIn) {
      // Token expiration is verified at App initialization
      // This component just checks localStorage presence as a quick check
      // 로그인 필요 시 현재 페이지를 저장하고 로그인 팝업 표시
      // 로그인 성공 후 원래 페이지로 돌아가기 위해 현재 경로 저장
      const currentPath = location.pathname + location.search;
      // OAuth 콜백·미정의 라우트(/login 등)는 저장하지 않거나 홈으로 정규화
      if (!location.pathname.startsWith('/oauth/callback')) {
        sessionStorage.setItem('redirectAfterLogin', getSafePostLoginRedirect(currentPath));
      }
      // 로그인 팝업 표시
      if (window.openLoginPopup) {
        window.openLoginPopup();
      }
    }
  }, [isLoggedIn, location]);

  // 로그인 상태면 자식 컴포넌트 랜더링, 없으면 빈 div
  return isLoggedIn ? (children || <div></div>) : null;
};

export default CheckLogin;